import { render, staticRenderFns } from "./PsConfigurationSocialsWorkers.vue?vue&type=template&id=6c8b88a6&scoped=true&"
import script from "./PsConfigurationSocialsWorkers.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationSocialsWorkers.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationSocialsWorkers.vue?vue&type=style&index=0&id=6c8b88a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b88a6",
  null
  
)

export default component.exports